import React, { Component } from 'react';
import { Modal, message, Spin } from 'antd';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';
import ComList from '../ComList';

const monthFormat = "YYYY-MM";

class UpdateLicence extends Component {
    state = {
        params: {},
        visible: false,
        loading: false,
    }

    show = (record) => {
        const params = {
            ...(record || {}),
        };
        this.setState({
            params,
            visible: true,
            isEdit: !!record,
        }, () => {
            this.queryVitaeList('LICENCES_CERTIFICATES_NAME');
        });
    }

    hide = () => {
        this.setState({
            visible: false,
            licenceOptions: [],
        });
    }

    queryVitaeList = (typeName) => {
        const options = {
            method: 'POST',
            url: API_URL.personal.queryVitaeList,
            data: {typeName},
            dataType: 'json',
            doneResult: res => {
                const { vitaeList = [] } = res;
                const options = vitaeList.map(item => {
                    const { vitaeDictId, chName, enName, childList } = item;
                    return {
                        zh: chName,
                        en: enName,
                        value: vitaeDictId,
                        child: childList,
                    };
                });
                this.setState({ licenceOptions: options });
            }
        };
        $.sendRequest(options);
    }

    getRenderList = () => {
        const { isChinese } = this.props;
        const { licenceOptions = [], params: { licencesCertificatesId } } = this.state;
        const licencesCertificatesName = ((licenceOptions || []).find(i => i.value == licencesCertificatesId) || {}).en;

        licenceOptions.forEach(i => i.name = isChinese ? i.zh : i.en);
        const renderList = [{
            zh: '执照/许可证/证书名称',
            en: 'Licences/Certificates Name',
            key: 'licencesCertificatesId',
            require: true,
            option: {
                type: 'select',
                allowClear: false,
                disabled: !isChinese,
                list: licenceOptions,
                style: { width: 200 },
                placeholder: isChinese ? '请选择' : 'Please select ',
            },
            attr: {
                left: { width: '41%' },
                right: { width: '59%' },
            }
        }];
        if (licencesCertificatesName === 'NMPA GCP certificate' || licencesCertificatesName === 'MedKey GCP certificate') {
            renderList.push({
                key: isChinese ? 'licencesGcpChinese' : 'licencesGcpEnglish',
                require: true,
                colon: false,
                option: {
                    type: 'input',
                    style: { width: 200 },
                    placeholder: isChinese ? '补充发证单位' : 'Please supply certification unit',
                },
                attr: {
                    left: { width: '41%' },
                    right: { width: '59%' },
                }
            });
        } else if (licencesCertificatesName == 'Other') {
            renderList.push({
                key: isChinese ? 'licencesOtherChinese' : 'licencesOtherEnglish',
                require: true,
                colon: false,
                option: {
                    type: 'input',
                    style: { width: 200 },
                    placeholder: isChinese ? '补充其他说明' : 'Please supply other instructions',
                },
                attr: {
                    left: { width: '41%' },
                    right: { width: '59%' },
                }
            });
        }
        renderList.push({
            zh: '获得证书日期',
            en: 'Certificate Date',
            key: 'certificateDate',
            require: true,
            option: {
                type: 'monthPicker',
                allowClear: false,
                format: monthFormat,
                disabled: !isChinese,
                style: { width: 200 },
                placeholder: isChinese ? '请选择' : 'Please select ',
            },
            attr: {
                left: { width: '41%' },
                right: { width: '59%' },
            }
        });
        const setName = (item) => {
            if (isChinese) {
                item.name = item.zh;
            } else {
                item.name = item.en;
            }
        };
        const loopArr = (arr) => {
            if (Array.isArray(arr)) {
                arr.forEach(item => loopArr(item));
            } else {
                setName(arr);
            }
        };
        loopArr(renderList);
        this.renderList = renderList;
    }

    checkValue = param => {
        const { params } = this.state;
        const { name, key, require, option, warning, display } = param;
        const { placeholder } = option;
        
        let noError = true;
        if (require) {
            if (!params[key] && !display) {
                message.warning(`${placeholder}${warning || name || ''}`);
                noError = false;
            } else {
                if (display) {
                    const { symbol, key, value = null } = display;
                    if (symbol === 'eq') {
                        if (value) {
                            const list = this.renderList || [];
                            const tar = list.find(i => i.key === key);
                            const arr = tar.option.list || [];
                            const o = arr.find(a => a.value == params[key]);
                            if (o && o.name === value && !params[param.key]) {
                                message.warning(`${placeholder}${warning || name || ''}`);
                                noError = false;
                            }
                        } else {
                            if (params[key] && !params[param.key]) {
                                message.warning(`${placeholder}${warning || name || ''}`);
                                noError = false;
                            }
                        }
                    }
                }
            }
        }
        return noError;
    }

    submit = () => {
        const {
            isEdit,
            params,
            params: {
                certificateDate,
            }
        } = this.state;
        const { userId, isChinese } = this.props;
        this.getRenderList();
        const renderList = this.renderList || [];
        const hasError = renderList.every(item => {
            if (Array.isArray(item)) {
                return item.every(i => this.checkValue(i));
            } else {
               return this.checkValue(item);
            }
        });
        if (!hasError) {
            return;
        }
        if (isEdit) {
            params.certificateDate = certificateDate ? certificateDate.slice(0, 7) : certificateDate;
        }
        params.type = isChinese ? 'CHINESE' : 'ENGLISH';
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.personal.saveVitaeLicencesCertificates,
            data: {
                userId,
                ...params,
            },
            dataType: 'json',
            doneResult: res => {
                message.success(res.success);
                this.setState({
                    loading: false,
                }, () => {
                    this.hide();
                    this.props.loadData();
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            }
        };
        $.sendRequest(options);
    }

    handleChange = (value, key) => {
        const { params } = this.state;
        const { isChinese } = this.props;
        params[key] = value;
        if (key === 'licencesCertificatesId') {
            const licencesGcp = isChinese ? 'licencesGcpChinese' : 'licencesGcpEnglish';
            const licencesOther = isChinese ? 'licencesOtherChinese' : 'licencesOtherEnglish';
            params[licencesGcp] = '';
            params[licencesOther] = '';
        }
        this.setState({ params });
    }

    render() {
        const { isEdit, visible, loading, params } = this.state;
        this.getRenderList();
        const list = this.renderList || [];
        return (
            <Modal
                title={`${isEdit ? '修改' : '新增'}执照/许可证/证书`}
                visible={visible}
                onCancel={this.hide}
                onOk={this.submit}
                className="create-modal EditPersonModal"
                confirmLoading={loading}
                maskClosable={false}
                width="520px"
            >
                 <Spin spinning={loading}>
                    <div className="modal-content" style={{ padding: '0 20px' }}>
                        <ComList
                            list={list}
                            params={params}
                            onChange={(value, key) => this.handleChange(value, key)}
                        />
                    </div>
                </Spin>
            </Modal>
        )
    }
}

export default UpdateLicence;


// WEBPACK FOOTER //
// ./src/components/common/curriculumVitae/UpdateLicence.js